export interface MapDetailsToolOptions {
  toggleLegendOnVisibilityChange?: boolean;
  excludeBaseLayers?: boolean;
  ogcFiltersInLayers?: boolean;
}
